@import '../../utils/visually-hidden.css';
@import '../../utils/forced-colors.css';

:host {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
  vertical-align: middle;

  --_badge-bg: var(--color-background-bold-brand);
  --_badge-fg: var(--color-foreground-on-bold-background-primary);
  --_badge-ring: var(--color-background-secondary);
  --_badge-ring-width: var(--dimension-stroke-width-018);
}

.badge__mark {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  box-sizing: border-box;
  color: var(--_badge-fg);
  background: var(--_badge-bg);
  box-shadow: 0 0 0 var(--_badge-ring-width) var(--_badge-ring);
  white-space: nowrap;
}

:host(.badge--no-ring) {
  --_badge-ring-width: 0;
}


:host(.badge--dot) .badge__mark {
  width: var(--dimension-size-075);
  height: var(--dimension-size-075);
  border-radius: var(--dimension-radius-half);
}

:host(.badge--counter) .badge__mark {
  width: auto;
  min-width: var(--dimension-size-150);
  height: var(--dimension-size-150);
  padding: 0 var(--dimension-space-025);
  border-radius: var(--dimension-radius-half);
}

/* Shell gradient ring — base fill + wash donut (option 3). */
:host(.badge--on-gradient-background) .badge__mark {
  position: relative;
  z-index: 0;
  box-shadow: none;
  isolation: isolate;
}

:host(.badge--on-gradient-background) .badge__mark::before,
:host(.badge--on-gradient-background) .badge__mark::after {
  content: '';
  position: absolute;
  inset: calc(-1 * var(--_badge-ring-width));
  border-radius: inherit;
  box-sizing: border-box;
  padding: var(--_badge-ring-width);
  pointer-events: none;
  /* stylelint-disable color-no-hex -- mask luminance stops for ring cutout, not theme colors */
  -webkit-mask:
    linear-gradient(#fff 0 0) content-box,
    linear-gradient(#fff 0 0);
  -webkit-mask-composite: xor;
  mask:
    linear-gradient(#fff 0 0) content-box,
    linear-gradient(#fff 0 0);
  /* stylelint-enable color-no-hex */
  mask-composite: exclude;
}

:host(.badge--on-gradient-background) .badge__mark::before {
  z-index: -2;
  background-color: var(--_badge-ring);
}

:host(.badge--on-gradient-background) .badge__mark::after {
  z-index: -1;
  background-image: var(--ds-shell-gradient-image, none);
  background-size: var(--ds-shell-gradient-size, auto);
  background-position: 0 0;
  background-repeat: no-repeat;
  background-attachment: fixed;
  opacity: var(--ds-shell-gradient-opacity, 1);
}

@media (forced-colors: active) {
  .badge__mark {
    color: var(--ds-forced-color-on-selected);
    background: var(--ds-forced-color-selected);
    box-shadow: none;
    outline: var(--_badge-ring-width) solid var(--ds-forced-color-surface);
  }

  :host(.badge--on-gradient-background) .badge__mark::before,
  :host(.badge--on-gradient-background) .badge__mark::after {
    display: none;
  }
}
